import DeliveryReceiptLink from '@components/DeliveryReceiptLink';
import MailLink from '@components/MailLink';
import PhoneLink from '@components/PhoneLink';
import SendDeliveryReceiptLink from '@components/SendDeliveryReceiptLink';
import { SendPudlReceiptProps } from '@/PickupDeliveryReceipt/types';

import styles from './ButtonContent.module.css';

export type DriverActionsProps = SendPudlReceiptProps & {
  isDriverAssigned?: boolean;
  puDlReceiptSent?: boolean;
};

/**
 * Same Driver Actions component without the leg API dependency
 */
export default function DriverActions({ isDriverAssigned, puDlReceiptSent, ...actionProps }: DriverActionsProps) {
  if (!actionProps.legId) {
    return null;
  }

  return (
    <div className={styles['driver-actions']}>
      <div className={styles['driver-action']}>{isDriverAssigned && <SendDeliveryReceiptLink {...actionProps} />}</div>

      <div className={styles['driver-action']}>{isDriverAssigned && puDlReceiptSent && <DeliveryReceiptLink legId={actionProps.legId} />}</div>

      <div className={styles['driver-action']}>
        {isDriverAssigned && (
          <MailLink
            emailAddress={actionProps.driverEmail ?? ''}
            showIcon={true}
          />
        )}
      </div>

      <div className={styles['driver-action']}>
        {isDriverAssigned && (
          <PhoneLink
            phoneNumber={actionProps.driverCellPhone ?? ''}
            showIcon={true}
          />
        )}
      </div>
    </div>
  );
}
